import { useProposalDocument } from "./proposalDocumentsContext";

const IntroForm: React.FC = () => {
  const { payload, setPayload } = useProposalDocument();

  return (
    <div className="card mb-4">
      <div className="card-header bg-primary text-white">
        <h4 className="mb-0">Document Intro</h4>
      </div>
      <div className="card-body">
        <div className="mb-3">
          <label htmlFor="proposal-intro-blurb" className="form-label">
            Who We Are Blurb
          </label>
          <textarea
            id="proposal-intro-blurb"
            className="form-control"
            rows={2}
            value={payload.who_we_are_blurb}
            onChange={(e) => {
              setPayload({ ...payload, who_we_are_blurb: e.target.value });
            }}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="proposal-intro-paragraphs" className="form-label">
            Who We Are Paragraphs (Separate by blank line)
          </label>
          <textarea
            id="proposal-intro-paragraphs"
            className="form-control"
            rows={6}
            value={payload.who_we_are_paragraphs.join("\n\n")}
            onChange={(e) => {
              setPayload({
                ...payload,
                who_we_are_paragraphs: e.target.value.split("\n\n"),
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default IntroForm;
